import { LandingTextBlock } from "../LandingTextBlock/LandingTextBlock";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererBody } from "./ContentRendererBody";

interface Props {
  body?: any;
  containerProps?: any;
  isCentered?: boolean;
  media?: any;
  title?: string;
  variant?: 'h1' | 'h2' | 'h3' | null;
}

export function ContentRendererTextBlock(block: Props) {
  const {
    body,
    isCentered,
    media,
    title,
    variant,
    containerProps
  } = block || {};

  const bodyVariantBy: Record<'h1' | 'h2' | 'h3', 'bodyXl' | 'bodyLg'> = {
    h1: 'bodyXl',
    h2: 'bodyLg',
    h3: 'bodyLg',
  };

  return (
    <ContentRendererContainer containerProps={containerProps}>
      <LandingTextBlock
        image={media?.data?.attributes?.url}
        isCentered={isCentered}
        title={title}
        variant={variant || 'h1'}
      >
        <ContentRendererBody
          body={body}
          paragraphVariant={bodyVariantBy[variant || 'h1']}
          paragraphSx={{ maxWidth: '956px' }}
        />
      </LandingTextBlock>
    </ContentRendererContainer>
  )
}
